export var TOP_BANNER_SKELETON = 'top-banner-skeleton';
//# sourceMappingURL=constants.js.map